import { useQuery } from '@tanstack/react-query'
import type { CustomsBrokerDto } from '@crm/shared'
import { getCustomsBrokers } from '../../../shared/api/customs.api'

/** Ключ кеша справочника брокеров — сбрасывается после создания и правки карточки. */
export const CUSTOMS_BROKERS_KEY = ['customs', 'brokers'] as const

/** Справочник брокеров нетарифки; `includeHidden` — со скрытыми (страница справочника). */
export function useCustomsBrokers(includeHidden = false) {
  return useQuery<CustomsBrokerDto[]>({
    queryKey: [...CUSTOMS_BROKERS_KEY, includeHidden ? 'all' : 'active'],
    queryFn: () => getCustomsBrokers(includeHidden),
    staleTime: 60_000,
  })
}

const LAST_BROKER_KEY = 'crm_customs_last_broker_v1'

/** Последний брокер, которому логист отправлял файл, — подставляется в окно «Отправить брокеру». */
export function readLastBroker(userId: string | undefined): string | null {
  if (!userId) return null
  try {
    return localStorage.getItem(`${LAST_BROKER_KEY}_${userId}`)
  } catch {
    return null
  }
}

export function saveLastBroker(userId: string | undefined, brokerId: string | null): void {
  if (!userId) return
  try {
    const key = `${LAST_BROKER_KEY}_${userId}`
    if (brokerId) localStorage.setItem(key, brokerId)
    else localStorage.removeItem(key)
  } catch {
    /* хранилище недоступно — просто не запоминаем */
  }
}
